import { call, put, takeEvery } from 'redux-saga/effects';
import { DeleteSalesRep, salesRepActionCreators, salesRepActionKeys } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { deleteSalesRep } from '../salesRepApi';

function* deleteSalesRepSaga(action: DeleteSalesRep) {
  yield put(uiActionCreators.showSpinnerDialog());

  const response: IApiExecuteRespone = yield call(deleteSalesRep, action.payload.sid);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else {
    yield put(salesRepActionCreators.removeSalesRep(action.payload.sid));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteSalesRep() {
  yield takeEvery(salesRepActionKeys.DELETE_SALES_REP, deleteSalesRepSaga);
}
